import { computed } from 'vue';
import { useFlag } from '@loadsmart/vue-feature-flags';

export default function useYardTasks() {
  const featureFlagYardTasksEnabled = useFlag('enable-yard-tasks');

  const isYardTasksEnabled = computed(() => {
    return Boolean(featureFlagYardTasksEnabled?.value.enabled);
  });

  return {
    isYardTasksEnabled
  };
}
